module.exports = __webpack_public_path__ + "img/Maskgroup.8d3ad922.png";